import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { InterviewController } from './interview.controller';
import { InterviewService } from './interview.service';
import { Interview } from './interview.entity';
import { interviewAdapter } from './dto/interview.adapter';
@Module({
  imports: [
    TypeOrmModule.forFeature([Interview]),
  ],
  controllers: [InterviewController],
  providers: [InterviewService,  interviewAdapter, ApplicationExceptionHandler],
  exports: [InterviewService]
})
export class InterviewModule {}



